"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var path_parser_1 = require("path-parser");
var util_1 = require("@aperza/util");
var AcTableColumn = /** @class */ (function () {
    function AcTableColumn() {
        this._selector = false;
        this._pageSizeDropdown = false;
        this._highlight = false;
        /**
         * conditional display table column
         */
        this._display = true;
    }
    AcTableColumn.fromColumns = function (columns) {
        return util_1.ArrayUtil.isNotEmpty(columns)
            ? columns
                .filter(function (c) { return c.display !== false; })
                .map(function (c) { return Object.assign(new AcTableColumn(), c); })
            : [];
    };
    AcTableColumn.prototype.hasPath = function () {
        return !!this.path;
    };
    AcTableColumn.prototype.buildPath = function (dataObject) {
        if (!dataObject || !this.path)
            return '';
        var pathParser = new path_parser_1.Path(this.path);
        return pathParser.build(dataObject);
    };
    AcTableColumn.prototype.buildValue = function (dataObject, context) {
        if (!this.data) {
            throw 'Unable to build value. data is missing!';
        }
        var value;
        if (typeof this.data === 'function') {
            value = this.data(dataObject, context);
        }
        else if (typeof this.data === 'string') {
            value = util_1.ObjectUtil.get(dataObject, this.data);
        }
        else {
            value = this.data;
        }
        return value;
    };
    Object.defineProperty(AcTableColumn.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this._title = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "actions", {
        get: function () {
            return this._actions;
        },
        set: function (value) {
            this._actions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "contacts", {
        get: function () {
            return this._contacts;
        },
        set: function (value) {
            this._contacts = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "selector", {
        get: function () {
            return this._selector;
        },
        set: function (value) {
            this._selector = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "pageSizeDropdown", {
        get: function () {
            return this._pageSizeDropdown;
        },
        set: function (value) {
            this._pageSizeDropdown = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "className", {
        get: function () {
            return this._className;
        },
        set: function (value) {
            this._className = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "headerClassName", {
        get: function () {
            return this._headerClassName;
        },
        set: function (value) {
            this._headerClassName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "path", {
        get: function () {
            return this._path;
        },
        set: function (value) {
            this._path = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "sortable", {
        get: function () {
            return this._sortable;
        },
        set: function (value) {
            this._sortable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "sortDirection", {
        get: function () {
            return this._sortDirection;
        },
        set: function (value) {
            this._sortDirection = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "onSort", {
        get: function () {
            return this._onSort;
        },
        set: function (value) {
            this._onSort = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "highlight", {
        get: function () {
            return this._highlight;
        },
        set: function (value) {
            this._highlight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "display", {
        get: function () {
            return this._display;
        },
        set: function (value) {
            this._display = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableColumn.prototype, "width", {
        get: function () {
            return this._width;
        },
        set: function (value) {
            this._width = value;
        },
        enumerable: true,
        configurable: true
    });
    return AcTableColumn;
}());
exports.AcTableColumn = AcTableColumn;
//# sourceMappingURL=AcTableColumn.js.map